import React from "react";
import LogoBadge from "./SVGComponents/LogoBadge";
import { gsap } from "gsap";
import { useGSAP } from "@gsap/react";
import LogoIcon from "./SVGComponents/LogoIcon";
import {
  RiFacebookFill,
  RiInstagramFill,
  RiLinkedinFill,
} from "react-icons/ri";
import footerLogo from "../../assets/REMA/venco-logo.svg";
import { FOOTER_LINKS } from "./constants";
import { Link } from "react-router-dom";
import IFMALogo from "./IFMALogo";

const MobileFooter = () => {
  const badgeRef = React.useRef(null);
  useGSAP(() => {
    // Badge rotation animation
    const spin = gsap.to(badgeRef.current, {
      rotation: 360,
      repeat: -1,
      ease: "linear",
      duration: 9,
      paused: false,
    });

    // Pause on hover
    const handleMouseEnter = () => spin.pause();
    const handleMouseLeave = () => spin.resume();

    if (badgeRef.current) {
      badgeRef.current.addEventListener("mouseenter", handleMouseEnter);
      badgeRef.current.addEventListener("mouseleave", handleMouseLeave);
    }

    // Cleanup function
    return () => {
      if (badgeRef.current) {
        badgeRef.current.removeEventListener("mouseenter", handleMouseEnter);
        badgeRef.current.removeEventListener("mouseleave", handleMouseLeave);
      }
      spin.kill();
    };
  }, []);
  return (
    <footer className="bg-[#CBF07F] lg:hidden py-[80px] px-4 sm:px-6 ">
      <div className="w-fit mx-auto space-y-16">
        {/* LOGO BADGE */}
        <div className=" w-full flex justify-center relative">
          <div className="absolute h-24 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 ">
            <LogoIcon />
          </div>
          <div ref={badgeRef}>
            <LogoBadge />
          </div>
        </div>

        {/* GET INVOLVED */}
        <div className="space-y-10 text-center ">
          <p className="font-sora text-sm font-medium text-[#6b9e03]">
            Get Involved:
          </p>
          <div className="space-y-8">
            {FOOTER_LINKS.map((link) => (
              <Link
                to={link.href}
                key={link.name}
                className="font-sora text-sm font-medium text-[#19443F] block"
              >
                {link.name}
              </Link>
            ))}
          </div>
        </div>

        <div className="bg-[#11302D] w-full h-px opacity-40" />

        {/* SOCIAL MEDIA */}
        <div className="space-y-8 text-center ">
          <p className="font-sora text-sm font-medium text-[#6b9e03]">
            Social Media:
          </p>
          <div className="flex gap-5 items-center justify-center">
            <div className="flex gap-2.5 text-[#19443F]">
              <a
                href="http://faceboook.com/vencohq"
                target="_blank"
                rel="noopener noreferrer"
                className="w-8 h-8 rounded-sm center p-1"
              >
                <RiFacebookFill className="text-[28px] " />
              </a>

              <a
                href="http://twitter.com/vencohq"
                target="_blank"
                rel="noopener noreferrer"
                className="w-8 h-8  rounded-md center p-1"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="100%"
                  height="100%"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="#19443F"
                    d="M8 2H1l8.26 11.014L1.45 22H4.1l6.388-7.349L16 22h7l-8.608-11.478L21.8 2h-2.65l-5.986 6.886L8 2Zm9 18L5 4h2l12 16h-2Z"
                  />
                </svg>
              </a>
              <a
                href="http://instagram.com/vencohq"
                target="_blank"
                rel="noopener noreferrer"
                className="w-8 h-8  rounded-md center p-1"
              >
                <RiInstagramFill className="text-[28px] " />
              </a>
              <a
                href="https://www.linkedin.com/company/Venco-hq/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-8 h-8  rounded-md center p-1"
              >
                <RiLinkedinFill className="text-[28px] " />
              </a>
            </div>
          </div>
        </div>

        <div className="bg-[#11302D] w-full h-px opacity-40" />

        {/* ORGANIZED BY */}
        <div className="space-y-5 text-center ">
          <p className="font-sora text-sm font-medium text-[#6b9e03]">
            Organized by:
          </p>
          <div className="flex gap-5 items-center justify-center">
            <a
              href="https://www.venco.africa/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={footerLogo} alt="" />
            </a>
          </div>
        </div>

        {/* ORGANIZED BY */}
        <div className="space-y-5 text-center ">
          <p className="font-sora text-sm font-medium text-[#6b9e03]">
            Endorsed by:
          </p>
          <div className="flex gap-5 items-center justify-center">
            <IFMALogo color="#1A1A1A" />
          </div>
        </div>

        <div className="bg-[#11302D] w-full h-px opacity-40" />

        {/* COPYRIGHT */}
        <div className="font-inter font-medium text-[#19443f] text-center text-sm">
          <p>2025 Rema Conference. All rights reserved</p>
        </div>
      </div>
    </footer>
  );
};

export default MobileFooter;
